import { render, staticRenderFns } from "./Child.vue?vue&type=template&id=69673a1a&"
import script from "./Child.vue?vue&type=script&lang=js&"
export * from "./Child.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69673a1a')) {
      api.createRecord('69673a1a', component.options)
    } else {
      api.reload('69673a1a', component.options)
    }
    module.hot.accept("./Child.vue?vue&type=template&id=69673a1a&", function () {
      api.rerender('69673a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Child.vue"
export default component.exports